export default "__VITE_ASSET__BfYKnlXf__"